import moment from "moment";
import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ceil, floor, orderBy } from "lodash";
import { icons } from "utils/constants";
import { getDataFromLocalStorage, titleCaseString } from "utils/helpers";
import {
  Modal,
  Button,
  Actionmenu,
  Multipleselectdropdown,
  Projectpopup,
} from "components";
import {
  setCopyData,
  deleteProjects,
  setProjectEditData,
  setIsShowProjectPopup,
  getProjects,
  setShowSubscriptionPopup,
  handelCatch,
  showSuccess,
  throwError,
  updateLogging,
  setIsOpen,
} from "store/globalSlice";
import "./Myprojects.scss";
import switchAnimation from "assets/images/animation/switchAnimation.json";
import Lottie from "lottie-react";
import Logs from "./Logs";

const globalLimit = 10;
const chainIcon = {
  unification: icons.unodeChain,
  shibarium: icons.shibariumChain,
  ethereum: icons.ethereumChain,
};
const Myprojects = () => {
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.global);
  const { networkType, isSubscription, isDarkMode, isOpen } = reduxData || {};
  const latestAccount = getDataFromLocalStorage("address");
  const [pageLoading, setPageLoading] = useState(true);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [deleteID, setDeleteID] = useState("");
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [myProjectList, setMyProjectList] = useState([]);
  const [actionID, setActionID] = useState(null);
  const [staticOption, setStaticOption] = useState(null);
  const [tableData, setTableData] = useState({
    networks: "",
    searchText: "",
    sortField: "",
    sortType: "",
    offset: 1,
    limit: globalLimit,
    total: 0,
  });

  const handleAddNetwork = async (elem) => {
    const { rpc_end_point, type, name } = elem;
    try {
      if (window.ethereum) {
        // await window.ethereum.enable();

        let customNetwork = {};
        if (type === "unification") {
          customNetwork = {
            chainId: `0x6D1`,
            chainName: name,
            nativeCurrency: {
              name: "UND",
              symbol: "UND",
              decimals: 18,
            },
            rpcUrls: [rpc_end_point],
          };
        } else if (type === "shibarium") {
          customNetwork = {
            chainId: `0x6D`,
            chainName: name,
            nativeCurrency: {
              name: "BONE",
              symbol: "BONE",
              decimals: 18,
            },
            rpcUrls: [rpc_end_point],
          };
        } else if (type === "ethereum") {
          customNetwork = {
            chainId: `0x1`,
            chainName: name,
            nativeCurrency: {
              name: "Ethereum",
              symbol: "ETH",
              decimals: 18,
            },
            rpcUrls: [rpc_end_point],
          };
        }

        await window?.ethereum?.request({
          method: "wallet_addEthereumChain",
          params: [customNetwork],
        });
        dispatch(showSuccess(`${name} is added Successfully`));
      } else {
        console.error("MetaMask not detected");
        dispatch(throwError("MetaMask not detected"));
      }
    } catch (error) {
      console.error("Error adding custom network:", error);
      dispatch(handelCatch(error));
    }
  };
  const headerOption = [
    {
      title: "#",
      className: "w5 cps-15",
      key: "index",
    },
    {
      title: "Project name",
      className: "w29",
      key: "name",
    },
    {
      title: "Network",
      className: "w14 text-capitalize",
      key: "network",
    },
    {
      title: "Requests(24h)",
      className: "w14 text-center justify-content-center",
      key: "query_count",
    },
    {
      title: "Failed requests(24h)",
      className: "w14 text-center justify-content-center",
      key: "fail",
    },
    {
      title: "Created on",
      className: "w14 text-center justify-content-center",
      key: "create_at",
    },
    {
      title: "Actions",
      className: "w10 text-center justify-content-center",
      key: "action",
    },
  ];
  const fetchProjects = async () => {
    const res = await dispatch(getProjects());
    let newList = res?.data?.map((elem) => {
      let newObject = {
        ...elem?.["Project"],
        type: elem?.type,
        sub_type: elem?.sub_type,
      };
      return newObject;
    });
    setTableData((prev) => {
      return { ...prev, total: newList?.length };
    });
    setMyProjectList(newList ? orderBy(newList, "project_id") : []);
    setPageLoading(false);
  };
  const handleDelete = async () => {
    setDeleteLoader(true);
    const res = await dispatch(deleteProjects(deleteID));
    if (res?.status === 200) {
      fetchProjects(tableData);
      setIsDeletePopup(false);
      dispatch(showSuccess(res?.data || "Project deleted successfully"));
    } else {
      dispatch(throwError(res?.data || "Something went wrong"));
    }
    setDeleteLoader(false);
  };
  const handlePagination = (type, data) => {
    switch (type) {
      case "next":
        setTableData((prev) => {
          return { ...prev, offset: data.activePage * tableData.limit + 1 };
        });
        break;
      case "prev":
        setTableData((prev) => {
          return { ...prev, offset: tableData.offset - tableData.limit };
        });
        break;
      case "limit":
        setTableData((prev) => {
          return { ...prev, offset: 1, limit: data.limitset };
        });
        break;
      case "page":
        setTableData((prev) => {
          return {
            ...prev,
            offset: data.page * tableData.limit - tableData.limit + 1,
          };
        });
        break;
      default:
        break;
    }
  };
  const handleSorting = (e) => {
    if (tableData?.sortField !== e) {
      setTableData((prev) => {
        return { ...prev, sortField: e, sortType: "asc" };
      });
    } else if (tableData?.sortField === e) {
      setTableData((prev) => {
        return {
          ...prev,
          sortField: tableData?.sortType === "asc" ? e : "",
          sortType: tableData?.sortType === "asc" ? "desc" : "",
        };
      });
    } else {
      console.log("NOTHING");
    }
  };
  const handleSearch = (e) => {
    setTableData((prev) => {
      return {
        ...prev,
        searchText: e?.target?.value,
        offset: 1,
        limit: globalLimit,
      };
    });
  };
  const handleNetworkChange = (e) => {
    const { networks } = tableData;
    let newList = networks ? networks?.split(",") : [];
    if (newList?.includes(e)) {
      newList = newList.filter((o) => o !== e);
    } else {
      newList = [...newList, e];
    }
    setTableData((prev) => {
      return {
        ...prev,
        networks: newList.toString(),
        offset: 1,
        limit: globalLimit,
      };
    });
  };
  const handleUpdateLogging = async () => {
    let payload = {
      status: JSON.stringify(!JSON.parse(actionID.logging)),
      apikey: actionID.apikey,
    };
    payload = new URLSearchParams(payload).toString();
    const res = await dispatch(updateLogging(actionID.project_id, payload));
    if (res?.status === 200) {
      dispatch(showSuccess(res?.data.message));
      setMyProjectList((prev) => {
        prev.forEach((elm) => {
          if (elm.project_id === actionID.project_id) {
            elm.logging = JSON.stringify(!JSON.parse(actionID.logging));
          }
        });
        return prev;
      });
      // fetchProjects()
      setActionID(null);
    }
  };

  useEffect(() => {
    setPageLoading(true);
    fetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latestAccount]);

  let displayList = myProjectList?.map((elem, index) => {
    const { network_id, created_at } = elem;
    const findValue = networkType?.find((o) => o.network_id === network_id);
    return {
      ...elem,
      index: index + 1,
      fail: 0,
      network: `${titleCaseString(findValue?.type)} ${titleCaseString(
        findValue?.sub_type
      )}`,
      create_at: moment(created_at).format("DD/MM/YYYY"),
    };
  });
  const networkFilterList = networkType?.map((elm) => {
    const { type, sub_type, network_id } = elm;
    return {
      id: `${network_id}`,
      label: `${titleCaseString(type)} ${titleCaseString(sub_type)}`,
    };
  });
  const {
    networks,
    searchText,
    sortField,
    sortType,
    offset,
    limit,
    // total: globaltotal,
  } = tableData;

  if (searchText) {
    displayList = displayList?.filter((o) =>
      o.name?.toLowerCase()?.includes(searchText?.toLowerCase())
    );
  }
  if (networks) {
    displayList = displayList?.filter((o) =>
      networks?.includes(`${o?.network_id}`)
    );
  }
  if (sortField) {
    displayList = orderBy(displayList, sortField, sortType);
  }
  let total = displayList.length;

  const totalPage = ceil(total / limit);
  const activePage = floor(offset / limit + 1);
  let page1 = activePage;
  let page2 = activePage + 1;
  let page3 = activePage + 2;
  if (activePage >= totalPage - 2) {
    page1 = totalPage - 2 <= 0 ? 1 : totalPage - 2;
    page2 = totalPage - 1 <= 1 ? 2 : totalPage - 1;
    page3 = totalPage - 0 <= 2 ? 3 : totalPage - 0;
  }

  displayList = displayList.slice(offset - 1, activePage * limit);

  let option = [];
  if (total >= 5) {
    option.push(5);
  }
  if (total > 5) {
    option.push(10);
  }
  if (total > 10) {
    option.push(15);
  }
  if (total > 15) {
    option.push(20);
  }
  if (total > 20) {
    option.push(total);
  }
  return (
    <div id="myprojects-container" className="cps-38 cpe-38 cpt-26 cpb-24">
      <Projectpopup
        fetchProjects={() => {
          fetchProjects(tableData);
        }}
      />
      {actionID && (
        <Modal width="368px" hideCloseButton isDarkMode={isDarkMode}>
          <div>
            <div className="f-center">
              <Lottie
                animationData={switchAnimation}
                loop={true}
                autoplay={true}
                style={{ height: "200px" }}
              />
            </div>
            <div
              className={`text-center text-18-600 ${
                isDarkMode ? "color-ffff" : "color-2749"
              } cmb-10`}
            >
              {actionID?.logging === "true" ? "Disable" : "Enable"} Logging
            </div>
            <div
              className={`text-center text-16-400 ${
                isDarkMode ? "color-c9c9" : "color-7e91"
              } cmb-26`}
            >
              {actionID?.logging === "true" ? (
                <div className="p-2">
                  This will permanently remove all logs previously enabled.
                </div>
              ) : (
                <>
                  Temporarily Enable Logging for <br /> this project
                </>
              )}
            </div>
            <div className="f-center gap-3">
              <Button
                btnStyle="GD"
                btnText="Cancel"
                className="cps-45 cpe-45"
                onClick={() => {
                  setActionID(null);
                }}
              />
              <Button
                btnStyle={actionID?.logging === "true" ? "SD" : "RD"}
                btnText={actionID?.logging === "true" ? "Disable" : "Enable"}
                className="cps-45 cpe-45"
                onClick={handleUpdateLogging}
              />
            </div>
          </div>
        </Modal>
      )}
      {isDeletePopup && (
        <Modal
          title="Delete project"
          width="600px"
          onHide={() => {
            setIsDeletePopup(false);
          }}
          isDarkMode={isDarkMode}
        >
          <div className="cps-26 cpe-26 cpt-26 cmb-10">
            <div className="h-175 cmb-26">
              <img
                src={isDarkMode ? icons.deleteFrameLight : icons.deleteFrame}
                alt="deleteFrame"
                className="fit-image"
              />
            </div>
            <div
              className={`text-center text-18-600 ${
                isDarkMode ? "color-ffff" : "color-2749"
              } cmb-10`}
            >
              Delete Confirmation !
            </div>
            <div
              className={`text-center text-16-400 ${
                isDarkMode ? "color-c9c9" : "color-7e91"
              } cmb-26`}
            >
              Are you sure you want to delete <br />
              this project
            </div>
            <div className="f-center gap-3">
              <Button
                btnStyle="GD"
                btnText="Cancel"
                className="cps-45 cpe-45"
                onClick={() => {
                  setIsDeletePopup(false);
                }}
              />
              <Button
                btnStyle="RD"
                btnText="Delete Project"
                loading={deleteLoader}
                onClick={handleDelete}
              />
            </div>
          </div>
        </Modal>
      )}
      {pageLoading ? (
        <>
          <div
            className={`${isDarkMode ? "skeleton-dark" : "skeleton"} h-45 br-4`}
          />
          <div
            className={`cmt-26 cp-24 ${
              isDarkMode ? "bg-102a" : "bg-f9fb"
            } flex-grow-1 d-flex flex-column`}
          >
            <div
              className={`${
                isDarkMode ? "skeleton-dark" : "skeleton"
              } h-45 br-4`}
            />
            <div
              className={`${
                isDarkMode ? "skeleton-dark" : "skeleton"
              } h-45 br-4 cmt-36 flex-grow-1`}
            />
          </div>
        </>
      ) : (
        <>
          {isOpen && (
            <Logs
              data={myProjectList}
              isDarkMode={isDarkMode}
              staticOption={staticOption}
            />
          )}
          <div className="fb-center">
            <div
              className={`text-20-700 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              My Projects
            </div>
            <div className="fa-center gap-3">
              {myProjectList?.length > 0 && (
                <>
                  <Button
                    btnStyle="PO"
                    className={isDarkMode ? "bg-tr" : ""}
                    btnText="Download Logs"
                    onClick={() => {
                      dispatch(setIsOpen(true));
                    }}
                  />
                </>
              )}
              <Button
                btnStyle="PD"
                btnText="Create New Project"
                leftIcon={icons.addSquare}
                onClick={() => {
                  if (isSubscription) {
                    dispatch(setProjectEditData(null));
                    dispatch(setIsShowProjectPopup(true));
                  } else {
                    dispatch(setShowSubscriptionPopup(true));
                  }
                }}
              />
            </div>
          </div>
          <div
            className={`cmt-26 cp-24  ${
              isDarkMode ? "bg-102a" : "bg-f9fb"
            } flex-grow-1 d-flex flex-column`}
          >
            <div className="fb-center">
              <div
                className={`${
                  isDarkMode
                    ? "project-search-block-dark"
                    : "project-search-block"
                }`}
              >
                <span className="s-icon-block">
                  <img
                    src={isDarkMode ? icons.searchLight : icons.search}
                    alt="wallet"
                    className="fit-image"
                  />
                </span>
                <input
                  type="text"
                  placeholder="Search Project Name"
                  onChange={handleSearch}
                  value={searchText}
                  // maxLength="30"
                />
              </div>
              <div className="w-300">
                <Multipleselectdropdown
                  value={networks}
                  options={networkFilterList}
                  onChange={handleNetworkChange}
                />
              </div>
            </div>
            <div
              className={`${
                isDarkMode ? "table-block-dark" : "table-block"
              } cmt-36`}
            >
              <div className="header-block">
                {headerOption.map((elem, index) => {
                  const { title, className, key } = elem;
                  return (
                    <div
                      className={`un header-option pointer ${className}`}
                      key={index}
                      onClick={() => {
                        if (key !== "action") {
                          handleSorting(key);
                        }
                      }}
                    >
                      <span className="me-1">{title}</span>
                      {key !== "action" && (
                        <>
                          <span className="h-10 d-flex">
                            <img
                              src={
                                isDarkMode
                                  ? icons.filterUpArrowLight
                                  : icons.filterUpArrow
                              }
                              alt="filterUpArrow"
                              className={`fit-image ${
                                sortField === key && sortType === "asc"
                                  ? "active-img"
                                  : sortField === key
                                  ? "d-none"
                                  : ""
                              }`}
                            />
                          </span>
                          <span className="h-10 d-flex">
                            <img
                              src={
                                isDarkMode
                                  ? icons.filterDownArrowLight
                                  : icons.filterDownArrow
                              }
                              alt="filterDownArrow"
                              className={`fit-image ${
                                sortField === key && sortType === "desc"
                                  ? "active-img"
                                  : sortField === key
                                  ? "d-none"
                                  : ""
                              }`}
                            />
                          </span>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
              <div
                className={`body-block ${
                  isDarkMode ? "custom-scroll-dark" : "custom-scroll"
                }`}
              >
                {displayList.map((elem, index) => {
                  return (
                    <div key={index} className="row-block">
                      {headerOption.map((cElem, cIndex) => {
                        return (
                          <div
                            key={cIndex}
                            className={`row-cell ${cElem.className}`}
                          >
                            {cElem.key === "index" ? (
                              elem?.[cElem.key] < 10 ? (
                                `0${elem?.[cElem.key]}`
                              ) : (
                                elem?.[cElem.key]
                              )
                            ) : cElem.key === "action" ? (
                              <Actionmenu
                                elem={elem}
                                handleApiKey={() => {
                                  dispatch(
                                    setCopyData({
                                      type: elem?.type,
                                      api_key: elem?.api_key,
                                      http_end_point: elem?.http_end_point,
                                      ws_end_point: elem?.ws_end_point,
                                      rpc_end_point: elem?.rpc_end_point,
                                    })
                                  );
                                }}
                                handleEdit={() => {
                                  dispatch(setIsShowProjectPopup(true));
                                  dispatch(setProjectEditData(elem));
                                }}
                                handleDelete={() => {
                                  setDeleteID(elem.project_id);
                                  setIsDeletePopup(true);
                                }}
                                handleAddNetwork={() => handleAddNetwork(elem)}
                                setActionID={setActionID}
                                handleDownloadLog={() => {
                                  setStaticOption(`${elem?.project_id}`);
                                  dispatch(setIsOpen(true));
                                }}
                              />
                            ) : cElem?.key === "name" ? (
                              <div className="fa-center gap-2">
                                <span className="h-30 d-flex">
                                  <img
                                    src={
                                      chainIcon[elem?.type] || icons.unodeChain
                                    }
                                    alt="chain"
                                    className="fit-image"
                                  />
                                </span>
                                <span>
                                  {" "}
                                  {elem?.[cElem.key]?.length > 30
                                    ? `${elem[cElem.key].substring(0, 30)}...`
                                    : elem?.[cElem.key]}
                                </span>
                              </div>
                            ) : (
                              elem?.[cElem.key]
                            )}
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
                {displayList.length === 0 && (
                  <div className="f-center h-100">
                    <div>
                      <div style={{ height: "100px" }}>
                        <img
                          src={
                            isDarkMode
                              ? icons.emptyProjectLight
                              : icons.emptyProject
                          }
                          alt="emptyProject"
                          className="fit-image"
                        />
                      </div>
                      <div
                        className={`text-16-600 ${
                          isDarkMode ? "color-ffff" : "color-2749"
                        } mt-3`}
                      >
                        You haven’t created project
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {displayList.length > 0 && (
                <div className="footer-block">
                  <div className="text-14-500 un">
                    <span
                      className={`${isDarkMode ? "color-c9c9" : "color-2749"}`}
                    >
                      Showing {offset} to{" "}
                      {activePage * limit > total ? total : activePage * limit}{" "}
                      of
                    </span>
                    <span className="color-56ff"> {total} entries</span>
                  </div>
                  <div className="fa-center">
                    {option.length > 0 && total > 5 && (
                      <div
                        className={`fa-center ${
                          isDarkMode ? "dropdownStyle" : ""
                        }`}
                      >
                        <div
                          className={`text-14-500 ${
                            isDarkMode ? "color-ffff" : "color-2749"
                          } cme-10 un`}
                        >
                          Display
                        </div>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                          >
                            <div
                              className={`fa-center  ${
                                isDarkMode ? "b-4d6c" : "b-edf0"
                              } br-4 pt-1 pb-1 ps-2 pe-2 gap-2 pointer`}
                            >
                              <span
                                className={`un ${
                                  isDarkMode ? "color-ffff" : "color-2749"
                                } w-20`}
                              >
                                {limit}
                              </span>
                              <span>
                                <img
                                  src={icons.pagination}
                                  alt="pagination"
                                  className="fit-image"
                                />
                              </span>
                            </div>
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            {option.map((elm, index) => {
                              return (
                                <Dropdown.Item
                                  key={index}
                                  className={`text-14-400 ${
                                    isDarkMode ? "color-ffff" : "color-2749"
                                  } ${
                                    option.length - 1 === index
                                      ? ""
                                      : "pb-2 bb-dee3"
                                  }`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handlePagination("limit", {
                                      limitset: elm,
                                    });
                                  }}
                                >
                                  {elm}
                                </Dropdown.Item>
                              );
                            })}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    )}
                    {totalPage > 1 && (
                      <div className="fa-center gap-2 cms-30">
                        <div
                          className={`icon-btn ${
                            activePage !== 1 ? "active-icon-btn" : ""
                          }`}
                          onClick={() => {
                            if (activePage !== 1) {
                              handlePagination("prev", {
                                activePage: activePage,
                              });
                            }
                          }}
                        >
                          <img
                            src={
                              activePage !== 1
                                ? icons.lightArrowLeft
                                : icons.darkArrowLeft
                            }
                            alt="darkArrowLeft"
                            className="fit-image"
                          />
                        </div>
                        <div
                          className={`page-btn ${
                            activePage === page1 ? "active-page-btn" : ""
                          }`}
                          onClick={() => {
                            handlePagination("page", { page: page1 });
                          }}
                        >
                          {page1}
                        </div>
                        <div
                          className={`page-btn ${
                            activePage === page2 ? "active-page-btn" : ""
                          }`}
                          onClick={() => {
                            handlePagination("page", { page: page2 });
                          }}
                        >
                          {page2}
                        </div>
                        <div
                          className={`page-btn ${
                            activePage === page3 ? "active-page-btn" : ""
                          } ${totalPage > 2 ? "" : "d-none"}`}
                          onClick={() => {
                            handlePagination("page", { page: page3 });
                          }}
                        >
                          {page3}
                        </div>
                        <div
                          className={`icon-btn ${
                            activePage !== totalPage ? "active-icon-btn" : ""
                          }`}
                          onClick={() => {
                            if (activePage !== totalPage) {
                              handlePagination("next", {
                                activePage: activePage,
                              });
                            }
                          }}
                        >
                          <img
                            src={
                              activePage !== totalPage
                                ? icons.lightArrowRight
                                : icons.darkArrowRight
                            }
                            alt="lightArrowRight"
                            className="fit-image"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Myprojects;
